import { Button, styled, Typography } from "@mui/material";
import { StyledAvatar } from "components/Shared/Dashboard/styled";
import { Form, useFormikContext } from "formik";
import UploadExcelComponent from "components/Input/UploadExcelComponent";
import { useDispatch, useSelector } from "react-redux";
import { apiSetAlert } from "api/appApi";
import uploadExcelImg from "assets/images/uploadExcel.svg";
import { tables } from "./SynchronizeComponent";
import { SelectInput } from "../../../Input/FormControl";
import { useEffect } from "react";
import { store } from "store/store";
import { excelSetTab } from "store/actions/excelAction";
const UploadComponentContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateRows: "50% 50%",
    maxHeight: "60vh",
    minHeight: "445px",
}));

const UpperComponent = styled("div")(({ theme }) => ({
    height: "100%",
    display: "grid",
    gridTemplateColumns: "60% 40%",
}));
const LowerComponent = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
}));
const GuideContainer = styled("div")(({ theme }) => ({
    height: "70%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
}));
const StyledSelect = styled("div")(({ theme }) => ({
    // border: `1px solid #C2D0E3`,
    // borderRadius: '4px',
    height: "38px !important",
    margin: "5px 0",
    width: "100%",
}));
const TemplateDownloadContainer = styled("div")(({ theme }) => ({
    height: "70%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
}));
const GuideItemContainer = styled("div")(({ theme }) => ({
    display: "flex",
}));

const GuidItem = ({ text, number }: { text: string; number: number }) => {
    return (
        <GuideItemContainer>
            <Typography variant="body2" fontWeight="bold">
                {`${number}.`}&nbsp;
            </Typography>
            <Typography variant="body2" color="#515151">
                {text}
            </Typography>
        </GuideItemContainer>
    );
};

const AvatarContainer = styled("div")(({ theme }) => ({
    width: "50px",
    height: "64px",
}));
const HeaderLogoPalceholder = () => {
    return (
        <AvatarContainer>
            <StyledAvatar sx={{ borderRadius: 0 }} src={uploadExcelImg} />
        </AvatarContainer>
    );
};

const guidItems = [
    "جدول مقصد اطلاعات خود را جهت ثبت انتخاب نمایید",
    "نمونه فایل اکسل را مشاهده یا دانلود نمایید",
    "فایل یا فایل های اکسل خود را انتخاب نمایید و مرحله بعد را بزنید",
    "ستون های فایل اکسل خود و جدول مقصد را همگام سازی نمایید ",
    "اطلاعات را ثبت نمایید",
];

const UploadComponent = () => {
    const initialValues = {};
    const { dispatch } = store
    //@ts-ignore
    const excelReducer = useSelector((state) => state).excelReducer;
    useEffect(() => {
        if (excelReducer.excelData && excelReducer.excelData !== null) {
            if (excelReducer.excelData.length) {
                //@ts-ignore
                dispatch(excelSetTab(excelReducer.excelData[0]));

            }
        }
    }, [excelReducer]);
    const onSubmit = (values: typeof initialValues) => {
        return "true";
    };
    const formikContext: any = useFormikContext();

    const exportFormTitles = (form: any, name: string) => {
        const titles: any[] = []
        Object.values(form).map((input) => {
            //@ts-ignore
            if (input && input.name && input.label) {
                //@ts-ignore
                titles.push({
                    //@ts-ignore
                    name: `${name}_${input.name}`,
                    //@ts-ignore
                    label: input.label,
                    //@ts-ignore
                    required: input.required ?? false,
                    //@ts-ignore
                    primary: input.primary ?? false,
                    //@ts-ignore
                    options: input.options ?? undefined,
                    //@ts-ignore
                    sheetName: input?.sheetName ?? undefined

                });
            }
        });
        return titles;
    };
    const compareTitles = (modelTitles: any[], excelTitles: any[]) => {
        //@ts-ignore
        modelTitles.map((m) => {
            //@ts-ignore
            const column = excelTitles.find((e) => e === m.label);
            console.log(column)
            // @ts-ignore
            // formikContext.setFieldValue(m.name, column ?? 'default')
            // formValues[m.name.split('.')[1]] = column ?? 'default'
            formikContext.setFieldValue(m.name, column ?? "default");
        });
    };
    const changeFormValue = (value: string, name: string) => {
        // if (excelReducer.activeTab) {
        //@ts-ignore
        let formValues = formikContext.values[`${name}_${value}`] ?? {};
        // if (name === `${excelReducer.activeTab?.key}_table`) {
        //@ts-ignore
        const modelFormData = tables.find((t) => t.value === value);
        if (modelFormData) {
            //@ts-ignore
            formValues = {
                ...formValues,
                ...modelFormData.form,
                modelTitles: exportFormTitles(modelFormData.form.modelTitles, `${name}${value}`),
            };
            //@ts-ignore
            compareTitles(formValues["modelTitles"], []);
        }
        formikContext.setFieldValue("colSelected", `${name}${value}`);
        formikContext.setFieldValue(`${name}${value}`, formValues);
        // }
        // formikContext.setFieldValue(name, value);
        const table = tables.find(x => x.value === value)
        if (table) {
            const { linkExample, label } = table
            formikContext.setFieldValue("link", linkExample ? linkExample : undefined);
            formikContext.setFieldValue("btnCaption", label);

        }
        // }
    };
    return (
        <Form style={{ width: "100%", height: "100%" }}>
            <UploadComponentContainer>
                <UpperComponent>
                    <GuideContainer>
                        <Typography>راهنما آپلود فایل:</Typography>
                        {guidItems.map((item, key) => (
                            <GuidItem key={key} text={item} number={key + 1} />
                        ))}
                    </GuideContainer>
                    <TemplateDownloadContainer>
                        <StyledSelect>
                            <Typography variant="body2">انتخاب جدول</Typography>
                            <SelectInput
                                name={`table`}
                                label={""}
                                onChange={changeFormValue}
                                selectOption={tables}
                            />
                        </StyledSelect>
                        <Button variant="outlined"
                            startIcon={<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M13.2459 9.6275C13.1042 9.345 12.8159 9.16668 12.5001 9.16668H10.8334V0.83332C10.8334 0.37332 10.4609 0 10.0001 0C9.53923 0 9.16673 0.37332 9.16673 0.83332V9.16664H7.50005C7.18423 9.16664 6.89587 9.34496 6.75423 9.62746C6.61423 9.90996 6.64423 10.2475 6.83341 10.5L9.33341 13.8333C9.34423 13.8475 9.36091 13.8525 9.37259 13.8658C9.42759 13.9308 9.49259 13.9808 9.56509 14.0266C9.59509 14.0449 9.61841 14.0691 9.65091 14.0841C9.75759 14.1341 9.87423 14.1666 10.0001 14.1666C10.126 14.1666 10.2426 14.1341 10.3501 14.0841C10.3818 14.0691 10.4059 14.0449 10.4351 14.0266C10.5076 13.9808 10.5726 13.9308 10.6276 13.8658C10.6384 13.8525 10.6559 13.8475 10.6668 13.8333L13.1668 10.5C13.3567 10.2475 13.3867 9.91 13.2459 9.6275Z"
                                    fill="#1062D0" />
                                <path
                                    d="M19.1667 12.5C18.7059 12.5 18.3334 12.8733 18.3334 13.3333V15.8333C18.3334 17.2116 17.2117 18.3333 15.8334 18.3333H4.16668C2.78836 18.3333 1.66668 17.2116 1.66668 15.8333V13.3333C1.66668 12.8733 1.29418 12.5 0.833359 12.5C0.3725 12.5 0 12.8733 0 13.3333V15.8333C0 18.1308 1.86918 20 4.16668 20H15.8334C18.1308 20 20 18.1308 20 15.8333V13.3333C20 12.8733 19.6275 12.5 19.1667 12.5Z"
                                    fill="#1062D0" />
                            </svg>
                            }
                            disabled={typeof formikContext.values["link"] === "undefined"}
                            disableRipple
                            disableElevation
                            disableFocusRipple
                            sx={{ borderWidth: '3px !important' }}
                        >
                            <a href={`${formikContext.values["link"]}`} target="_blank"
                                rel="noreferrer">
                                &nbsp;&nbsp;{
                                    ` دانلود فایل نمونه ${formikContext.values["btnCaption"] ? formikContext.values["btnCaption"] : ""}`

                                }
                            </a>

                        </Button>
                    </TemplateDownloadContainer>
                </UpperComponent>
                <LowerComponent>
                    <UploadExcelComponent
                        title="فایل اکسل خود را انتخاب کنید یا بکشید و اینجا رها کنید"
                        name="header"
                        width="100%"
                        height="100%"
                        innerWidth="97%"
                        innerHeight="90%"
                        // horizontal={true}
                        LogoPlaceholder={HeaderLogoPalceholder}
                        disableLayer={true}
                    />
                </LowerComponent>
            </UploadComponentContainer>
        </Form>
    );
};

const ActionContainer = styled("div")(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const UploadAction = ({ onSubmit, onIgnore }: { onSubmit: () => void; onIgnore: () => void }) => {
    const dispatch = useDispatch();
    //@ts-ignore
    const excelReducer = useSelector((state) => state).excelReducer;
    const formikContext: any = useFormikContext();
    const values = formikContext.values
    return (
        <ActionContainer>
            <Button
                variant="outlined"
                color="disabled"
                disableRipple
                disableElevation
                sx={{ borderWidth: "3px !important" }}
                disableFocusRipple
                onClick={() => onIgnore()}
            >
                انصراف
            </Button>
            <Button
                variant="contained"
                startIcon={
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.75461 4.53949C6.89629 4.82199 7.18461 5.00031 7.50043 5.00031H9.16711V13.3337C9.16711 13.7937 9.53961 14.167 10.0004 14.167C10.4613 14.167 10.8338 13.7937 10.8338 13.3337L10.8338 5.00035H12.5004C12.8163 5.00035 13.1046 4.82203 13.2463 4.53953C13.3863 4.25703 13.3563 3.91953 13.1671 3.66703L10.6671 0.333713C10.6563 0.319533 10.6396 0.314533 10.6279 0.301212C10.5729 0.236213 10.5079 0.186213 10.4354 0.140392C10.4054 0.122072 10.3821 0.0978918 10.3496 0.0828915C10.2429 0.0328913 10.1263 0.00039196 10.0004 0.00039196C9.87454 0.00039196 9.7579 0.0328913 9.6504 0.0828915C9.61872 0.0978918 9.59457 0.122072 9.5654 0.140392C9.4929 0.186213 9.42789 0.236213 9.3729 0.301212C9.36207 0.314533 9.34457 0.319533 9.33372 0.333713L6.83372 3.66703C6.64375 3.91949 6.61375 4.25699 6.75461 4.53949Z"
                            fill="white"
                        />
                        <path
                            d="M19.1667 12.5C18.7059 12.5 18.3334 12.8733 18.3334 13.3333V15.8333C18.3334 17.2116 17.2117 18.3333 15.8334 18.3333H4.16668C2.78836 18.3333 1.66668 17.2116 1.66668 15.8333V13.3333C1.66668 12.8733 1.29418 12.5 0.833359 12.5C0.3725 12.5 0 12.8733 0 13.3333V15.8333C0 18.1308 1.86918 20 4.16668 20H15.8334C18.1308 20 20 18.1308 20 15.8333V13.3333C20 12.8733 19.6275 12.5 19.1667 12.5Z"
                            fill="white"
                        />
                    </svg>
                }
                onClick={() => {
                    if (excelReducer && excelReducer.excelData) {
                        console.log(excelReducer.excelData)
                        if (!values.colSelected && typeof !values.colSelected === "string") {
                            //@ts-ignore
                            return dispatch(apiSetAlert("لطفا ابتدا جدول را انتخاب کنین", "warning"));

                        }
                        // if(form)
                        if (excelReducer.excelData.length > 0) {
                            dispatch(excelSetTab(excelReducer.excelData[0]));
                            onSubmit();
                        } else {
                            // @ts-ignore
                            dispatch(apiSetAlert("فایل انتخابی دارای اطلاعات نیست", "warning"));
                        }
                    } else {
                        // @ts-ignore
                        dispatch(apiSetAlert("لطفا فایل اکسل خود را انتخاب نمایید", "warning"));
                    }
                }}
                disableRipple
                disableElevation
                disableFocusRipple
                sx={{ borderWidth: "3px !important" }}
            >
                &nbsp;&nbsp; مرحله بعد
            </Button>
        </ActionContainer>
    );
};

export default UploadComponent;
